// @flow

import * as React from 'react';

import useI18n from 'src/hooks/useI18n';

import FileButton from 'src/components/lib/file-button';
import {StringErrorBox} from 'src/components/lib/error-box';

import css from './file-page.css';


const CsvModal = ({
  errors,
  onFileChange,
  onCancel,
  uploadLimit,
}: {
  errors?: string[],
  onFileChange: (event: SyntheticEvent<HTMLInputElement>) => any,
  onCancel: (event: SyntheticEvent<HTMLElement>) => any,
  uploadLimit: number,
}): React.Element<'div'> => {
  const {labelI18nInstance} = useI18n();

  const t = labelI18nInstance.t;

  return (
    <div className={css.root}>
      {errors && <StringErrorBox errors={errors} />}

      <div className={css.columns}>
        <div className={css.rules}>
          <div>{`${t('Your_CSV_must', 'Your CSV must')}`}</div>
          <ul>
            <li>
              {`${t('Contain_a', 'Contain a')}`}{' '}
              <strong>{`${t('phone', 'phone')}`}</strong>{' '}
              {`${t('column', 'column')}`}
            </li>
            <li>
              {`${t('Contain_a', 'Contain a')}`}{' '}
              <strong>{`${t('name_column_s', 'name column(s)')}`}</strong>
            </li>
            <li>
              {`${t('Be', 'Be')}`} <strong>{uploadLimit}</strong>{' '}
              {`${t('contacts_or_fewer', 'contacts or fewer')}`}
            </li>
            <li>{`${t('Have_a_header_row', 'Have a header row')}`}</li>
          </ul>
        </div>

        <div className={css.example}>
          <div className={css.exampleHead}>
            <span>{`${t('Example_format', 'Example format')}:`}</span>
            <a
              href="https://s3-us-west-2.amazonaws.com/madeby.com/assets/contacts-example.csv"
              target="_blank"
            >{`${t('Download_Template', 'Download Template')}`}</a>
          </div>
          <img
            src="/images/chat/csv-template@1x.png"
            srcSet="/images/chat/csv-template@2x.png 2x"
          />
        </div>
      </div>

      <div className={css.actions}>
        <div className={css.hide}>{`${t('Cancel', 'Cancel')}`}</div>
        <FileButton onChange={onFileChange} accept=".csv">{`${t(
          'Select_File_to_Upload',
          'Select File to Upload',
        )}`}</FileButton>
        <button className={css.cancel} onClick={onCancel}>{`${t(
          'Cancel',
          'Cancel',
        )}`}</button>
      </div>
    </div>
  );
};
export default CsvModal;
